import React, {ReactElement} from 'react';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import {VariantType, OnChangeType} from './LabPartnersTypes';

interface Props {
    formStyle: {[key: string]: string | number};
    inputLabel: ReactElement | null;
    value: string;
    onChange: OnChangeType;
    variant: VariantType;
    opts: ReactElement[];
}

export const LabPartners = (props: Props) => {
    const {formStyle, inputLabel, value, onChange, variant, opts} = props;

    return (
        <FormControl style={formStyle}>
            {inputLabel}
            <Select
                labelId="lab-partners-label"
                value={value}
                onChange={onChange}
                variant={variant}
            >
                <MenuItem value="">
                    <em>ALL</em>
                </MenuItem>
                {opts}
            </Select>
        </FormControl>
    );
};
